<template>
    <app-modal-view @close="$emit('close')">
        <template #header>
            <div class="lb-project-modal-header">
                <div class="level is-mobile">
                    <div class="level-left">
                        <div class="level-item">
                            <p
                                v-t="'add_group'"
                                class="has-text-weight-bold is-size-5"
                            ></p>
                        </div>
                    </div>
                    <div class="level-right">
                        <div class="level-item buttons">
                            <button
                                v-t="'Buttons.save'"
                                :class="{
                                    'is-loading': saving,
                                    'is-warning': error,
                                }"
                                class="button is-primary"
                                @click="saveChanges"
                            />
                            <button
                                v-t="'Buttons.cancel'"
                                class="button is-dark"
                                @click="
                                    $emit('update:active', false);
                                    $emit('close', false);
                                "
                            />
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template #body>
            <div class="columns">
                <div class="column table-container">
                    <div class="field">
                        <label v-t="'Classes.class_name'" class="label" />
                        <div class="field">
                            <div class="control">
                                <input
                                    v-model="groupTemplate.name"
                                    :placeholder="
                                        $t('Classes.creation_name_placeholder')
                                    "
                                    class="input"
                                    type="text"
                                />
                            </div>
                        </div>
                    </div>
                    <label v-t="'Classes.add_school_members'" class="label" />
                    <div class="field">
                        <p class="control has-icons-left">
                            <input
                                v-model="username"
                                :placeholder="$t('search')"
                                class="input"
                                type="text"
                                @input="fetchUsers"
                            />
                            <span class="icon is-small is-left">
                                <i class="mdi mdi-24px mdi-magnify"></i>
                            </span>
                        </p>
                    </div>

                    <table
                        class="table is-bordered is-fullwidth is-hoverable is-headless"
                    >
                        <tbody>
                            <tr
                                v-for="user in remainingUsers"
                                :key="user._id"
                                @click="members.push(user)"
                            >
                                <td>
                                    <app-user-row :user="user">
                                        <template #action>
                                            <button
                                                v-t="'Buttons.add'"
                                                class="button is-flat is-primary is-inverted is-paddingless"
                                            />
                                        </template>
                                    </app-user-row>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="column table-container lb-group-members-column">
                    <label v-t="'Classes.members_counts'" class="label" />
                    <table
                        class="table is-bordered is-fullwidth is-striped is-headless"
                    >
                        <tbody>
                            <tr
                                v-for="(member, index) in members"
                                :key="member._id"
                                @click="members.splice(index, 1)"
                            >
                                <td class="has-background-pale-grey">
                                    <app-user-row :user="member">
                                        <template #action>
                                            <button
                                                v-t="'Buttons.remove'"
                                                class="button is-flat is-dull-red is-inverted has-background-pale-grey is-paddingless"
                                            />
                                        </template>
                                    </app-user-row>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </template>
    </app-modal-view>
</template>

<script>
import AppModalView from '@/components/AppModalView';
import AppUserRow from '@/components/AppUserRow';
import { updateItem, createItem, fetchSchoolMembers } from '@/services/API';
import _ from 'underscore';
export default {
    components: {
        AppModalView,
        AppUserRow,
    },
    props: {
        active: {
            type: Boolean,
            default: false,
        },
        group: {
            type: Object,
            default: () => {
                return { name: undefined, description: undefined, members: [] };
            },
        },
    },
    data() {
        return {
            groupTemplate: this.group,
            saving: false,
            error: false,
            username: undefined,
            loadingUsers: false,
            users: [],
            members: [],
        };
    },
    computed: {
        remainingUsers() {
            return _.filter(this.users, (user) => {
                return !_.findWhere(this.members, { _id: user._id });
            });
        },
    },
    watch: {
        username: {
            handler: 'fetchUsers',
            immediate: true,
        },
        'group.members': {
            handler() {
                this.members = [...this.group.members];
            },
            immediate: true,
        },
        error() {
            this.saving = false;
        },
    },
    mounted() {
        this.fetchUsers();
    },
    methods: {
        async saveChanges() {
            this.saving = true;
            let response;
            if (!this.groupTemplate._id) {
                response = await createItem('group', {
                    ...this.groupTemplate,
                    ...{ members: this.members },
                }).catch(() => {
                    this.error = true;
                });
            } else {
                response = await updateItem('group', this.groupTemplate._id, {
                    ...this.groupTemplate,
                    ...{ members: this.members },
                }).catch(() => {
                    this.error = true;
                });
            }
            this.saving = false;
            if (response) {
                this.$emit('update:active', false);
                this.$emit('created', response.data);
            }
        },
        fetchUsers: _.debounce(async function (params) {
            this.loadingUsers = true;
            this.users = [];
            let response = await fetchSchoolMembers({
                username_contains: this.username,
                email_contains: this.username,
                _offset: this.users.length,
                _limit: 20,
            });
            this.loadingUsers = false;
            this.users = response.data;
        }, 400),
    },
};
</script>

<style scoped></style>
